<template lang="pug">
  hotsite-dgc
    .conteudo
      bloco#dgc_orientacoes.-nomargin.-softpadding.-fullheight
        //- HEADER
        header(slot="header")
          titulo.-withbar.-upper Orientações e Manuais
        //- CONTENT
        .texto(slot="content")
          p Aqui você encontra as orientações e manuais para download
          mensagem.-warn
            p Nenhuma orientação ou manual foi encontrada no momento
        //- FOOTER
        footer(slot="footer")
          back-and-share
</template>

<style lang="scss">
  #dgc_orientacoes {
    .lista {
      > .item {
        @extend %font_medium;
        font-size: 18px;

        &:before {
          font-family: 'FontAwesome';
          font-size: 1.4rem;
          margin-right: 15px;
        }

        &.pasta:before { content: '\f07b' }
        &.arquivo:before { content: '\f15b' }
      }
    }
  }

  #hotsite {
    .corpo {
      .conteudo {
        #dgc_orientacoes {
          ul.pagination {
            li:before {
              display: none !important;
            }
          }
        }
      }
    }
  }
</style>

<script>
import BackAndShare from 'COMPONENTS/BackAndShare'
import Bloco from 'COMPONENTS/Bloco'
import HotsiteDgc from 'PAGES/dgc/Base'
import Mensagem from 'COMPONENTS/Mensagem'
import Titulo from 'COMPONENTS/ElementTitle'

export default {
  components: {
    BackAndShare,
    Bloco,
    HotsiteDgc,
    Mensagem,
    Titulo
  }
}
</script>




// WEBPACK FOOTER //
// Orientacoes.vue?285291a1